import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { GraphContent} from './ColGraph.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  Title,
  BarElement,
  CategoryScale, // Explicitly importing PieController
} from 'chart.js';

  ChartJS.register(
    CategoryScale,
    BarElement,
    Title,
  );

import { Bar } from 'react-chartjs-2';

interface IProps { data?: any }



export const ColGraph = (props: IProps) => {
  const {client } = useStore();  
  const i18n = useI18n();
  const [data, setData] = useState(null)
  const ref = useRef(null)


  useEffect(() => {
    getData()
  }, [props.data])

  
  const getData = () => {
    // //@ts-ignore
    // let bar_ctx = document.getElementById('chart_bar')?.getContext('2d');

    // let background_1 = bar_ctx?.createLinearGradient(150, 0, 0, 0);
    // background_1?.addColorStop(0, '#2A848E');
    // background_1?.addColorStop(0.8, '#04A7B9');

    // let background_2 = bar_ctx?.createLinearGradient(150, 0, 0, 0);
    // background_2?.addColorStop(0, '#FED425');
    // background_2?.addColorStop(0.8, '#C7B35D');

    // let background_3 = bar_ctx?.createLinearGradient(150, 0, 0, 0);
    // background_3?.addColorStop(0, '#FA505E');
    // background_3?.addColorStop(0.8, '#BD3944');


    let t = {
      labels: [i18n.t("present-header"), i18n.t("graph-late"), i18n.t("absent")],
      datasets: [{
        label: ' ',
        data: [props.data.present, props.data.late, props.data.absent],
        backgroundColor: ["#2A848E", "#FED425", "#FA505E"],
        datalabels: {
          align: 'start',
          anchor: 'end',
          offset:-20,
          font: {
            color: '#696969',
            size: '14',
            weight: 'bold',
          }
        }
      }]
    }

    setData(t)
  }
  
  

  const options = {
    responsive:true,
    maintainAspectRatio: false,
    barThickness: 'flex',
    scales: {
      y:{
        display:false,
        grace:"20%",
      },
      x:{
        title:{
          color:"#414141",
        },
        grid:{
          display:false,
        }
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip:{
        enabled:false,
      },
    },
    layout:{
      autoPadding:false,
    }
  }

  
  return (<>
      <GraphContent>
        {data !== null?<Bar data={data} plugins={[ChartDataLabels]} options={options} />:null}
      </GraphContent>
  </>);
};

export default ColGraph;
